var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaiduProvider',{attrs:{"apiKey":_vm.getConfig.baiduMapsApiKey,"markers":_vm.markers,"options":{
    zoom: _vm.zoom,
    center: _vm.center,
    mapTypeSelector: _vm.mapTypeSelector,
  }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }